module.exports = __webpack_public_path__ + "img/company_logo_white.24489427.png";